






































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { FetchState } from "@/shared/types";
import Widget from "@/shared/components/Widget.vue";
import TransactionListItem from "@/shared/components/ui/TransactionListItem.vue";
import Pagination from "@/shared/components/ui/Pagination.vue";
import _ from "lodash";
import { Location } from "vue-router";
import { useHsaStore } from "@/shared/store/hsa";
import { useHsaPendingTransactionStore } from "@/shared/store/hsaPendingTransaction";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component ({
  components: {
    Widget,
    TransactionListItem,
    Pagination
  }
})
export default class ContributionsGrid extends Vue {
  hsaStore = useHsaStore();
  pendingTransactionStore = useHsaPendingTransactionStore();
  custodianSettingsStore = useCustodianSettingsStore();

  @Prop()
  page: number;

  @Prop()
  routeToPages: (page) => Location;

  @Prop({required: false})
  username: string;

  @Prop({required: false})
  partnerId: number;

  get combinedContributionActivity (): any {
    if (this.page === 1) {
      return _.orderBy(this.pendingTransactionStore.contributionActivity.concat(this.hsaStore.contributionsForCurrentPage), ["postedDate"], ["desc"]);
    }

    return this.hsaStore.contributionsForCurrentPage;
  }

  mounted () {
    this.pendingTransactionStore.fetchContributionActivity({ username: this.username, partnerId: this.partnerId});
    this.loadPage();
  }

  get isLoaded (): boolean {
    return this.hsaStore.fetchState === FetchState.Loaded && this.pendingTransactionStore.contributionActivityIsLoaded;
  }

  @Watch("$props", { deep: true })
  loadPage () {
    this.hsaStore.loadHsaContributionsDictionary({
      pageNumber: this.page,
      username: this.username,
      partnerId: this.partnerId
    }).catch(() => null); // the store rethrows the error
    this.hsaStore.setHsaPageNumber(this.page);
  }

  switchPage (toPage): void  {
    this.$router.push(this.routeToPages(toPage));
  }

  get pageButtonsStartValue (): number {
    return this.page - 2 > 0 ? this.page - 2 : 1;
  }

  get contributionsPageButtonRange (): number[] {
    const endValue = this.page + 3 < this.hsaStore.contributionsPageCount ?
      (this.page + 3) : (this.hsaStore.contributionsPageCount + 1);
    return _.range(this.pageButtonsStartValue, endValue);
  }

  get hasContributionsFooter (): boolean {
    return this.custodianSettingsStore.contributionsFooter as any;
  }

  get widgetTitle () {
    if (this.isLoaded) {
      const countOfContributions = this.combinedContributionActivity.length;
      const pluralization = countOfContributions !== 1 ? "s" : "";
      const asterisk = this.hasContributionsFooter ? "*" : "";
      return `${countOfContributions} Contribution${pluralization}${asterisk}`;
    }
    return "";
  }
}
